import { render, staticRenderFns } from "./HeaderBar.vue?vue&type=template&id=a49af85a&scoped=true&"
import script from "./HeaderBar.vue?vue&type=script&lang=js&"
export * from "./HeaderBar.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBar.vue?vue&type=style&index=0&id=a49af85a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a49af85a",
  null
  
)

export default component.exports